<template>
  <v-layout row>
    <v-flex xs12>
      <v-toolbar color="blue-grey">
        <v-toolbar-title>Challenge</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          @click="postChallenge"
        >
          Post
        </v-btn>
        <v-badge
          overlap
          :color="item.posts > 0 ? 'blue' : 'grey'"
        >
          <span slot="badge">{{ item.points }}</span>
          <v-icon
            large
            :color="item.posts > 0 ? 'yellow darken-2' : 'grey darken-2'"
          >
            star
          </v-icon>
        </v-badge>
      </v-toolbar>
      <v-card>
        <blockquote class="blockquote">
          {{ item.challenge }}
        </blockquote>
        <fullscreen ref="fullscreen" @change="fullscreenChange">
          <div :style="`height:${height};`">
            <slider ref="slider" :options="{loop:true}">
                <slideritem
                    v-for="(example, index) in item.examples"
                    :key="example.id"
                    :style="`width:${width};`"
                >
                    <v-img
                        v-if="example.type == 'image'"
                        :src="example.url"
                        height="100%"
                        :contain="true"
                        style="cursor:pointer;"
                        @click="toggle(index)"
                    ></v-img>
                    <video
                        v-else
                        style="height:100%;cursor:pointer;"
                        @click="toggle(index)"
                    >
                        <source :src="example.url" :type="example.mimeType">
                    </video>
                </slideritem>
            </slider>
          </div>
        </fullscreen>
        <Posts :challenge="id"></Posts>
        <v-snackbar
          v-model="snackbar"
          color="error"
          :timeout="10000"
          :top="true"
        >
          {{ error }}
          <v-btn
            dark
            flat
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import Posts from './Posts.vue'
  import carousel from 'v-owl-carousel'
  import fullscreen from 'vue-fullscreen'
  import { slider, slideritem } from 'vue-concise-slider'
  import Vue from 'vue'

  Vue.use(fullscreen)

  export default {
    props: ['id'],
    components: {
      Posts,
      carousel,
      slider,
      slideritem
    },
    data () {
      return {
        snackbar: false,
        error: "",
        challenge: {},
        item: {},
        slide: 1,
        width: '10em',
        height: '10em',
        slide: 1
      }
    },
    methods: {
      toggle (index) {
          if (this.fullscreen) {
              return;
          }
          
          this.slide = index;
          this.$refs['fullscreen'].toggle();
      },
      fullscreenChange (fullscreen) {
          this.fullscreen = fullscreen;

          if (fullscreen) {
              this.width = '100%';
              this.height = '100%';

              this.$el.querySelector('.slider-pagination').hidden = true;

              const video = document.getElementsByTagName('video');
              
              for (let i = 0; i < video.length; i++) {
                  video[0].controls = true;
              }

              this.$refs['slider'].$emit('slideTo', this.slide);
          }
          else {
              this.width = '10em';
              this.height = '10em';

              this.$el.querySelector('.slider-pagination').hidden = false;

              const video = document.getElementsByTagName('video');
              
              for (let i = 0; i < video.length; i++) {
                  video[0].controls = false;
              }
          }
      },
      fullscreenSlideMovement (e) {
          if (e.key == 'ArrowLeft') {
              this.$refs['slider'].$emit('slidePre');
          }
          
          if (e.key == 'ArrowRight') {
              this.$refs['slider'].$emit('slideNext');
          }
      },
      populateItem () {
        this.item = {
          id: this.id,
          categories: [],
          challenge: this.challenge.challenge,
          points: this.challenge.points,
          examples: [],
          posts: this.challenge.posts.length
        };

        this.challenge.categories.map((category, idx) => {
          this.item.categories.push(category.title);
        });

        this.challenge.examples.map((example, idx) => {
            const type = example.mime.split('/')[0];

            if (type != 'image' && type != 'video') {
              return;
            }
            
            this.item.examples.push({
              id: example.id,
              type: type,
              mimeType: example.mime,
              url: example.url
            });
        });
      },
      postChallenge () {
        this.$router.push({
          name: 'post',
          query: {
            challenge: this.id
          }
        });
      }
    },
    created () {
      this.$http.api.checkLogin();
    },
    mounted () {
      const url = `/challenges/${this.id}`;

      this.$http.api.get(url)
      .then(response => {
        this.challenge = response.data;

        this.populateItem();
      })
      .catch(error => {
        if (error.response) {
          this.error = this.$http.api.getError(error).toString;
          this.snackbar = true;
        }
        else {
          console.dir(error);
        }
      });
    }
  }
</script>